export default __webpack_public_path__ + "assets/docs/EULA.5328fdd4.pdf";